import styled from "styled-components";
import bg from "assets/images/franchising2024/desktop.jpg";
import bgFull from "assets/images/franchising2024/desktop-full.jpg";
import bgMobile from "assets/images/franchising2024/mobile.jpg";
import medinaCaio from "assets/images/franchising2024/medina-caio.png";
import listStyle from "assets/images/franchising2024/list-style.png";
import { colors, fonts } from "styles";

export const Container = styled.section`
  position: relative;
  width: 100%;
  min-height: 700px;
  margin: 0 auto;
  background: url(${bg}) no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 100px;
  @media (max-width: 1720px) {
    background: url(${bgFull}) no-repeat center center;
  }
  @media (max-width: 1160px) {
    background: url(${bg}) no-repeat -200px center;
  }
  @media (max-width: 950px) {
    background: url(${bg}) no-repeat -300px center;
  }
  @media (max-width: 820px) {
    background: url(${bgMobile}) no-repeat center center;
    background-size: 100% auto;
    margin: 0;
    min-height: 522px;
  }
`;
